<template>
  <div style="support">
    <h4 class="title is-4">Initial response to equipment problems</h4>
    <p>
      If you think it is not working properly, please check the following<br />
    </p>
    <hr />
    <h5 class="title is-5">Camera Unit</h5>
    <ul class="description">
      <li>
        Make sure the power switch on the main unit is in the "ON" position.
      </li>
      <li>
        Make sure you are in movie mode (see *How to check the mode).
      </li>
      <li>
        Make sure that the signal is good (*Refer to How to Check Antenna
        Strength).
      </li>
      <li>
        Verify that the registration to Device Config in the Pescle web system
        is correct
      </li>
      <ul class="description">
        <li>Make sure "Trail Camera" is selected.</li>
        <li>Make sure the serial number is correct.</li>
      </ul>
      <li>Replace all batteries with new ones and check.</li>
    </ul>
    <hr />
    <h5 class="title is-5">How to check the shooting mode</h5>
    <p>
      The trail camera has two modes: video mode and still image mode.<br />
      PESCLE uses video to determine vermin. Please check your settings to make
      sure you are in video mode.
    </p>
    <div class="columns mt-4">
      <div class="column is-one-quarter">
        <img src="/img/trailcam.png" class="image" />
      </div>
      <div class="column">
        <table class="table">
          <thead>
            <tr>
              <th width="20%" class="has-text-centered">Number</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="has-text-centered is-vcentered">1</td>
              <td>
                Set the power switch in the center of the device to "SETUP".
              </td>
            </tr>
            <tr>
              <td class="has-text-centered is-vcentered">2</td>
              <td>
                With the SETUP screen on,
                <span class="check"
                  >Icon is video mode(<i class="fas fa-video"></i>video
                  mark)</span
                >Please make sure that the "L" is set to "1". In the case of
                still image mode, make sure that
                <i class="fas fa-camera"></i>
                It is a camera mark.
              </td>
            </tr>
            <tr>
              <td class="has-text-centered is-vcentered">※</td>
              <td>
                At the SETUP screen,
                <span class="check">Press ▲ and ▼ to switch modes and</span>, So
                please be careful not to press it. If the mode switches, press ▲
                and ▼ to change the mode.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <hr />
    <h5 class="title is-5">How to check antenna strength</h5>
    <p>
      The trail camera uses cellular phone lines for communication.<br />
      If you cannot communicate, please check the signal conditions.
    </p>
    <div class="columns mt-4">
      <div class="column is-one-quarter">
        <img src="/img/trailcam2.png" class="image" />
      </div>
      <div class="column">
        <table class="table">
          <thead>
            <tr>
              <th width="20%" class="has-text-centered">Number</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="has-text-centered is-vcentered">1</td>
              <td>
                Set the power switch in the center of the device to "SETUP".
              </td>
            </tr>
            <tr>
              <td class="has-text-centered is-vcentered">2</td>
              <td>
                With the SETUP screen on, press ▲▼ to switch to the still image
                mode.
              </td>
            </tr>
            <tr>
              <td class="has-text-centered is-vcentered">3</td>
              <td>
                The antenna symbol appears only when the camera is in still
                image mode (camera symbol).
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="notification is-danger is-light">
      To use PESCLE properly, the trail camera must be set to video mode.<br />
      After checking the antenna strength, be sure to return to the video mode.
    </div>
  </div>
</template>
<style>
.support {
  margin-bottom: 64px;
}
.description {
  margin: 0 0 0 1em;
  list-style-type: circle;
}

.check {
  font-weight: bold;
  color: red;
}

.image {
  width: 200px;
}
</style>
